import script from "./ShareholderSharesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholderSharesTable.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholderSharesTable.vue?vue&type=style&index=0&id=079b6d80&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079b6d80"]])

export default __exports__